import { Subject } from 'rxjs';
import { CdsAppEvent } from '@oolio-group/domain';

// Not a BehaviorSubject: replaying the last request to a late subscriber would
// re-launch a charge the customer already dealt with.
export const cdsAppEventsSubject = new Subject<CdsAppEvent[]>();
